import { INVENTORY } from "Constants/pathNames"
import React from "react"

function DashboardStoreInventory() {
  return <div>I am Inventory</div>
}
export const name = INVENTORY
export default DashboardStoreInventory
